var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.isNeedDesc)?_c('strong',{style:({paddingTop:_vm.descPt,paddingBottom:_vm.descPb})},[_vm._v(_vm._s(_vm.desc))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }